import React from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import "./Dashboard.css";

const CertificationDashboard = () => {
  return (
    <div className="eit-dashboard">
      <img className="FAQ__banner" src="/images/dashboard/banner.png" alt="banner" />                 
      <iframe className="certification-report" title="E&I Certification Dashboard" width="1140" height="541.25" 
        src="https://app.powerbi.com/reportEmbed?reportId=a60ec734-f1ff-490b-8fe7-ebcb9828e897&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb" 
        frameborder="0" allowFullScreen="true">        
      </iframe>
      {/* <PowerBIEmbed
          embedConfig = {{
            type: 'report',   
            id: 'a60ec734-f1ff-490b-8fe7-ebcb9828e897',
            embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=a60ec734-f1ff-490b-8fe7-ebcb9828e897',
            accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IlQxU3QtZExUdnlXUmd4Ql82NzZ1OGtyWFMtSSIsImtpZCI6IlQxU3QtZExUdnlXUmd4Ql82NzZ1OGtyWFMtSSJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvZTA3OTNkMzktMDkzOS00OTZkLWIxMjktMTk4ZWRkOTE2ZmViLyIsImlhdCI6MTcwMTc3MDM3NSwibmJmIjoxNzAxNzcwMzc1LCJleHAiOjE3MDE3NzUxMTMsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBWVFBZS84VkFBQUF4RUJ6K1hPRjRHQmRwbVQwT2xsLzdyYW5mbFFKbERzZERWRWJnU2pNWkoyb2NKRHFzb09KUG5aQ0dkeUlMRzAvU0RGNGVqbUFWeS9EbTc0L3dLd01rR0NjWDRscXJjd3BGUmU3aHRtMUFoODNiOTZkcXhadC9CT294SjZHb3J0eG41cElUbkRkL0IrR015YTBQZDl6NlpXb0ZpdGg0akhEZ3VRd28vRHVlNlU9IiwiYW1yIjpbInJzYSIsIm1mYSJdLCJhcHBpZCI6Ijg3MWMwMTBmLTVlNjEtNGZiMS04M2FjLTk4NjEwYTdlOTExMCIsImFwcGlkYWNyIjoiMCIsImNvbnRyb2xzIjpbImFwcF9yZXMiXSwiY29udHJvbHNfYXVkcyI6WyIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAiXSwiZGV2aWNlaWQiOiJhYTM0ZDZkZS03NTY4LTQwMDMtOWVkOC01M2M4YzJhMDU1NmYiLCJmYW1pbHlfbmFtZSI6Ik1pc2hyYSIsImdpdmVuX25hbWUiOiJBbmt1ciIsImlwYWRkciI6IjI0MDE6NDkwMDo0MTk4OjcyODY6NjQyMjpmNzNlOmNiODg6N2Y0NyIsIm5hbWUiOiJNaXNocmEsIEFua3VyIiwib2lkIjoiYjhkYTllMjItMjllNS00MzI0LWJjOTktZGVlYjBmYThhZDg3Iiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTMyOTA2ODE1Mi0xNDU0NDcxMTY1LTE0MTcwMDEzMzMtMTE2Mzc2NDMiLCJwdWlkIjoiMTAwMzIwMDFDNjEzMDE4NCIsInJoIjoiMC5BWHNBT1QxNTREa0piVW14S1JtTzNaRnY2d2tBQUFBQUFBQUF3QUFBQUFBQUFBQjdBR1EuIiwic2NwIjoidXNlcl9pbXBlcnNvbmF0aW9uIiwic2lnbmluX3N0YXRlIjpbImR2Y19tbmdkIiwiZHZjX2NtcCIsImR2Y19kbWpkIiwia21zaSJdLCJzdWIiOiJ2VG9ibmFJTUtEYmlvakIzSFppNll4X2VCZWtIVTV6V3NVRHlpU3hTbVBJIiwidGlkIjoiZTA3OTNkMzktMDkzOS00OTZkLWIxMjktMTk4ZWRkOTE2ZmViIiwidW5pcXVlX25hbWUiOiJhbmt1ci5lLm1pc2hyYUBhY2NlbnR1cmUuY29tIiwidXBuIjoiYW5rdXIuZS5taXNocmFAYWNjZW50dXJlLmNvbSIsInV0aSI6InB3QWhIdTZEU0Uyeng3d3ktTDhjQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdfQ.OavAE2gNGEDVvlzUMVjzPsl83ezIVfYKYquZT0zrVig6NQXpQXSmd4xm3uBvdl4M3YU2zTZn1zXWa-Qvb1ucYJ5WFaLpqbpOLB63DCYeKWTknacULonkth3gPAum6uGl2w-Ig7_FiLX3jWD810Cne_TOueZNblo-_3jFfMRDiaL0GcmDkzXKIQFH738zuuVXMJdvSVVSRSR3FX5_gp6L_mdEmEwvE17pqGf4w6MPsupAND8FZmjf4VSxalnVH2EbwP7EZf3mbXC4Cux8lagENNfd3Z9EMl38ihkys5KJbIyUGQOtpiS0UlWSqV9UaFY-4chgzXELeO6ymls-pbgQgw',
            tokenType: models.TokenType.Aad,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false
                }
              },
              background: models.BackgroundType.Transparent,
            }
          }}
          eventHandlers = {
            new Map([
              ['loaded', function () {console.log('Report loaded');}],
              ['rendered', function () {console.log('Report rendered');}],
              ['error', function (event) {console.log(event.detail);}],
              ['visualClicked', () => console.log('visual clicked')],
              ['pageChanged', (event) => console.log(event)],
            ])
          }
	        cssClassName = { "embed-container" }
          getEmbeddedComponent = { (embeddedReport) => {
            window.report = embeddedReport;
          }}
      /> */}
    </div>
  );
};

export default CertificationDashboard;
